import { FileUploader } from "angular-file-upload";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { CredentialsManager } from "../../shared/credentials-manager";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { VoterFileImport } from "../../models/voter-file-import.model";
import { Utils } from "../../helper/utils.helper";
import { PermissionCheck } from "../../shared/permission";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";

let VoterFileListComponent = {
    selector: "vcVoterFileList",
    templateUrl:
        "/angular/components/voter-file/voter-file-list.component.html",
    bindings: {},
    controller: class VoterFileListController {
        private readonly $scope: any;
        private $window: any;
        private credentialsManager: CredentialsManager;
        private dataProvider: VoterFileDataProvider;
        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;
        private $filter: any;
        public readonly __env: any;
        public readonly screen: ScreenUtils;

        public voterFileString: string;
        public registers: VoterFileImport[] = [];
        public registers_loading = true;
        public readonly helpText: string;
        public readonly buttonText: string;
        public readonly isLeaderView: boolean;
        public uploader: FileUploader;
        public permissionProvider: PermissionCheck;
        private defaultDialogs: DefaultDialogs;

        public essentialsMode: boolean;

        constructor(
            $scope: any,
            $window: any,
            CredentialsManager: CredentialsManager,
            VoterFileDataProvider: VoterFileDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            $filter: any,
            __env: any,
            __app_type: string,
            Utils: Utils,
            ScreenUtils: ScreenUtils,
            PermissionCheck: PermissionCheck,
            DefaultDialogs: DefaultDialogs
        ) {
            Utils.accessCheck();
            this.$scope = $scope;
            this.$window = $window;
            this.credentialsManager = CredentialsManager;
            this.dataProvider = VoterFileDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.$filter = $filter;
            this.__env = __env;
            this.screen = ScreenUtils;
            this.permissionProvider = PermissionCheck;
            this.defaultDialogs = DefaultDialogs;
            this.helpText =
                "Hello and welcome to " +
                this.__env.product_name +
                "! Choose an option below to begin importing your " +
                this.__env.strings.voter_file +
                "!";
            this.buttonText = "Upload " + this.__env.strings.voter_file;
            this.isLeaderView = __app_type === "LEADER";

            this.essentialsMode =
                CampaignDataProvider.getActiveCampaign().campaignstatusid ==
                "5";

            this.dataProvider.getVoterFiles().then((voterFiles: any[]) => {
                this.registers = voterFiles;
                this.registers_loading = false;
            });

            this.uploader = this.dataProvider.getVoterFileUploader();
            this.uploader.onWhenAddingFileFailed = (item: any): void => {
                // Maximum file size is 500MB
                if (item && item.size >= 524288000) {
                    this.toast.error("This file is too big");
                } else {
                    this.toast.error("This file type is not supported");
                }
            };
        }

        inProgress(statusID: number): boolean {
            return statusID != 1 && statusID < 7;
        }

        showEssentialsDialog(ev: any): void {
            this.dialog.show({
                component: "vc-feature-disabled-dialog",
                targetEvent: ev,
                size: "large",
                scope: this.$scope,
                locals: {
                    essentials: true,
                },
            });
        }

        importInfo(register: VoterFileImport | null): void {
            if (this.isLeaderView) {
                this.$window.location = `./leader.php/#/leader_voterfiles/info/${
                    register.erid
                }${!!register.imid ? `/${register.imid}` : ""}`;
            } else {
                if (register.statusid() == 14) {
                    let openInfoModal = this.dialog
                        .alert()
                        .title("Queued")
                        .htmlContent(
                            `<span>Your file has been added to the import queue for processing.</span><br/>
                            <span> The status will be updated as soon as processing has commenced.</span>`
                        )
                        .ok("OK");
                    this.dialog.showPreConfiguredDialog(openInfoModal);
                } else if (
                    !register.readyToImport() ||
                    (!!register.imid && register.importInProgress())
                ) {
                    let openInfoModal = this.dialog
                        .alert()
                        .title("Advisory")
                        .htmlContent(
                            `<span>This import is currently in progress.</span><br/>
                            <span>The information related to the import will be available as soon as the import has been completed</span>`
                        )
                        .ok("OK");
                    this.dialog.showPreConfiguredDialog(openInfoModal);
                } else {
                    this.$window.location = `./#/voterfiles/info/${
                        register.erid
                    }${!!register.imid ? `/${register.imid}` : ""}`;
                }
            }
        }

        openChangePlanDialog(ev: any): void {
            if (
                this.permissionProvider.hasStripeSubscription &&
                this.permissionProvider.hasPermission("CHANGE_PLAN")
            ) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: "change",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.defaultDialogs.contactSupport(
                    "Upgrade subscription",
                    " upgrading the subscription",
                    ev
                );
            }
        }
    },
};

angular
    .module("voterFile")
    .component(VoterFileListComponent.selector, VoterFileListComponent);
